import { graphql, useStaticQuery } from 'gatsby'

export const use404Image = () => {
  return useStaticQuery(
    graphql`
      query fourZeroFourImage {
        image: file(relativePath: { eq: "404.jpg" }) {
          childImageSharp {
            gatsbyImageData(quality: 80, placeholder: BLURRED, layout: FULL_WIDTH)
          }
        }
      }
    `,
  )
}
